import React, { useState, useRef, useEffect } from "react";
import CryptoJS from "crypto-js";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import {
  countryWithPhonelenght,
  emailValidation,
} from "../../hooks/HelperFunctions";

import { Grid } from "@material-ui/core/";
import Buttons from "../../components/Button/Button";
import TextField from "../../components/TextField/TextField";
import PasswordStrength from "../../components/FieldPassword/PasswordStrength";
import AlrtMessage from "../../components/AlrtMessage/AlrtMessage";
import fbIcon from "../../assets/imgs/socialIcon/fb-icon.png";
import google from "../../assets/imgs/socialIcon/google.png";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import CallTwoToneIcon from "@mui/icons-material/CallTwoTone";
import PhoneInputField from "../../components/PhoneInputField/PhoneInputField";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import Button from "@mui/material/Button";
import styles from "./form.module.css";
import { useRouter } from "next/router";
import { useShoppingCart } from "../../contexts/CartContext";
import { color, fontWeight } from "@mui/system";

function SignUp(props) {
  const { cartItems, setCartItems } = useShoppingCart();
  const [password, setPassword] = useState("");
  const [passwordValidation, setPasswordValidation] = useState(true);

  const [onboardStudent, setOnboardStudent] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [fieldErrors, setFieldErrors] = useState({
    first_name: false,
    last_name: false,
    email: false,
    phone_number: false,
  });
  const [phoneError, setPhoneError] = useState(false);
  const [values, setValues] = React.useState({});
  const [captchaToken, setCaptchaToken] = useState("");

  const [orgId, setOrgId] = useState(0);

  useEffect(() => {
    setOrgId(localStorage.getItem("orgId"));
  }, []);

  // function handleReCaptcha(value) {
  //   console.log("Captcha value:", value);
  //   setCaptchaToken(value);
  // }
  const router = useRouter();
  const handleChanges = (fieldName, value) => {
    const fieldValue = fieldName == "email" ? value.toLowerCase() : value;
    console.log(fieldName, fieldValue);

    setValues({
      ...values,
      [fieldName]: fieldValue,
    });
  };
  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//

  const signUpHandler = async (postData) => {
    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    postData["password"] = password;

    setAlertSeverity("error");

    if (postData.password == "") {
      // show validation error message
      setAlertMessage("Password is required.");
      setAlertOpen(true);
      return false;
    } else if (passwordValidation == false) {
      // show password validation error message
      setAlertMessage("Password should have matched all the below criteria.");
      setAlertOpen(true);
      return false;
    }
    ///===================== recapcha ==============================///
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        // add aditional data
        postData["org_id"] = orgId;
        postData["user_role"] = "student";
        postData["password_confirmation"] = postData.password;
        postData["orgWebsite"] = window.location.origin;
        postData["sign_up_with"] = props.signUpWith;
        postData["phone_number"] = `${postData.phone_number}`;
        postData["token"] = token;
        postData["invite_token"] =
          props.active_modal === "sign_up" ? props.invite_token : "";
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        // console.log(postData, 345);

        axios
          .post(`${baseUrl}/register`, postData)
          .then((response) => processStudentSignUp(response))
          .catch((err) => {
            console.log(err);
            if (err.response.data.message) {
              setAlertMessage(err.response.data.message);
              setAlertOpen(true);
            }
          });
      } catch (error) {
        console.error("Error:", error);
      }
    });
  };

  const alertCloseHandler = () => {
    setAlertOpen(false);
  };

  const processStudentSignUp = (result) => {
    console.log(result);
    const response = result.data;
    if (response.error) {
      setAlertSeverity("error");
      setAlertMessage(
        props.signUpWith == "phone_number"
          ? `It seems that there is already an existing account associated with this phone number.`
          : `It seems that there is already an existing account associated with this email address.`
      );
      setAlertOpen(true);
    } else {
      const userData = {
        id: response.body.id,
        firstName: response.body.first_name,
        lastName: response.body.last_name,
        email: response.body.email,
        phone_number: response.body.phone_number,
        image: response.body.image,
        // "orgId": response.body.org_id,
        userRole: response.body.user_role,
      };

      // set user data and user access token
      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("userToken", response.token);
      localStorage.setItem("jwtToken", response?.data?.jwt_token);
      // set user as authorized
      localStorage.setItem("userAuthenticated", true);
      // set user id related data
      // localStorage.setItem('orgId', response.body.org_id);
      // localStorage.setItem('stuId', response.body.stuId);

      // show success message
      setAlertSeverity("success");
      setAlertMessage("Sign Up Success!");
      setAlertOpen(true);
      if (props.organization_invitation) {
        localStorage.setItem("invite_token", props.invite_token);
        router.push("/create-new-teaching-account");
      } else {
        setTimeout(() => {
          if (props.active_modal) {
            window.location.href = `/`;
          } else {
            if (typeof window !== "undefined") {
              window.location.reload(false);
            }
          }
        }, 2000);

        router.push("/");
      }
      props.setActiveModalForSignUp("");
      props.handleCloseWelcomeSignUp();
    }
  };

  const signUpStepOne = (postData) => {
    let errors = [];

    if (!postData?.first_name) {
      errors.push("First name is required.");
      setFieldErrors((prevErrors) => ({ ...prevErrors, first_name: true }));
    } else {
      setFieldErrors((prevErrors) => ({ ...prevErrors, first_name: false }));
    }

    if (!postData?.last_name) {
      errors.push("Last name is required.");
      setFieldErrors((prevErrors) => ({ ...prevErrors, last_name: true }));
    } else {
      setFieldErrors((prevErrors) => ({ ...prevErrors, last_name: false }));
    }

    if (props.signUpWith === "phone_number" && !postData?.phone_number) {
      errors.push("Phone number is required.");
      setFieldErrors((prevErrors) => ({ ...prevErrors, phone_number: true }));
    } else {
      setFieldErrors((prevErrors) => ({ ...prevErrors, phone_number: false }));
    }
    if (props.signUpWith === "email" && !postData.email) {
      errors.push("Enter a valid email address.");
      setFieldErrors((prevErrors) => ({ ...prevErrors, email: true }));
    } else {
      setFieldErrors((prevErrors) => ({ ...prevErrors, email: false }));
    }

    if (phoneError) {
      errors.push("Enter a valid phone number.");
    }

    // Add additional validations here if needed

    // Display errors if any
    if (errors.length > 0) {
      // setAlertSeverity("error");
      // setAlertMessage(errors.join("\n")); // Join errors into a single string
      // setAlertOpen(true);
      return false;
    }
    setAlertOpen(false);
    setOnboardStudent(true);
    return true;
  };

  //== Phone Field State start== //
  const [phone, setPhone] = React.useState({
    country: "",
    number: "",
  });
  //== Phone Field State end== //

  const phoneChangeHandler = (ext, number) => {
    const getCountryDataWithPhoneLength = countryWithPhonelenght();
    let data = number.slice(ext?.dialCode?.length);
    let findLength = getCountryDataWithPhoneLength?.find(
      (item) => item?.phone == ext.dialCode && item?.label == ext.name
    )?.phoneLength;

    if (data?.length < findLength) {
      setPhoneError(true);
    } else {
      setPhoneError(false);
    }
    handleChanges("phone_number", `${number}`);
  };

  const handleBack = () => {
    setOnboardStudent(false);
  };
  const handleBack2 = () => {
    props.handleClose();
    props.handleOpenWelcomeSignUp();
  };
  return (
    <>
      <div className={styles.SignContainer}>
        <div className={styles.SignContainerInner}>
          <div className={styles.BackButton}>
            <Button
              variant="text"
              onClick={
                onboardStudent ? () => handleBack() : () => handleBack2()
              }
            >
              <ArrowBackIosNewRoundedIcon /> Back
            </Button>
          </div>

          <div className={styles.SignForm}>
            {onboardStudent ? <h1>Create new password</h1> : <h1>Sign up</h1>}
            <Grid container spacing={onboardStudent ? 1 : 2}>
              <Grid item xs={12} md={12}>
                <AlrtMessage
                  open={alertOpen}
                  message={alertMessage}
                  severity={alertSeverity}
                  closeHandler={alertCloseHandler}
                />
              </Grid>
              {onboardStudent ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <PasswordStrength
                      placeholder="Password"
                      error={password?.length === 0 ? alertMessage : ""}
                      handlePasswordText={setPassword}
                      handlePasswordValidation={setPasswordValidation}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Buttons
                      label="Create Account"
                      buttonColor="#004FE0"
                      border="#ccc 1px solid"
                      color="#fff"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() => signUpHandler(values)}
                    />
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} md={6}>
                    <TextField
                      placeholder="First name"
                      required={true}
                      error={fieldErrors.first_name ? "error" : ""}
                      helperText={fieldErrors.first_name ? "Required" : ""}
                      value={values.first_name}
                      handleChange={(value) =>
                        handleChanges("first_name", value)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      placeholder="Last name"
                      required={true}
                      error={fieldErrors.last_name ? "error" : ""}
                      helperText={fieldErrors.last_name ? "Required" : ""}
                      value={values.last_name}
                      handleChange={(value) =>
                        handleChanges("last_name", value)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    {props.signUpWith == "email" && (
                      <TextField
                        placeholder="Email"
                        required={true}
                        email={true}
                        error={fieldErrors.email ? "error" : ""}
                        helperText={fieldErrors.email ? "Required" : ""}
                        value={values.email}
                        handleChange={(value) => handleChanges("email", value)}
                      />
                    )}

                    {props.signUpWith == "phone_number" && (
                      <PhoneInputField
                        phoneInputVariant={"materialui"} // default, materialui, underlineInput, underlineWithFlag
                        country={"us"}
                        value={phone.number}
                        countryCodeEditable={false}
                        // onChange={(phone, country) => console.log("onChange", phone, country)}
                        onChange={(phone, country) =>
                          phoneChangeHandler(country, phone)
                        }
                        // onChange={(phone, country) =>
                        //   phoneChangeHandler(country.dialCode, phone)
                        // }
                        onBlur={() => console.log("onBlur")}
                        onKeyDown={(e) =>
                          console.log("onKeyDown", e.target.value)
                        }
                        variant="outlined"
                        // onlyCountries={["us", "ca", "gb", "my"]}
                        containerStyle={{}}
                        buttonStyle={{}}
                        inputStyle={{
                          marginLeft: "0px",
                          height: "56px",
                          width: "100%",
                          fontFamily: "Roboto-Regular",
                          fontSize: "16px",
                        }}
                        containerClass={{}}
                        // errorText={
                        //   phoneError ? "Enter a valid phone number" : ""
                        // }
                        errorStyles={{
                          marginBottom: "5px",
                          marginLeft: "-6px",
                          fontWeight: 500,
                          color: "#d32f2f",
                        }}
                        autoFormat={true}
                        disableDropdown={false}
                        disabled={false}
                        disableCountryCode={false}
                        enableSearch={false}
                        disableSearchIcon={false}
                        placeholder={""}
                        inputProps={{}}
                        specialLabel={"Primary Phone"}
                        // preferredCountries={[]}
                        // excludeCountries={[]}
                        // error="error"
                        error={fieldErrors.phone_number ? "error" : ""}
                        errorText={
                          fieldErrors.phone_number
                            ? "Enter a valid phone number"
                            : ""
                        }
                      />
                    )}

                    <div className={styles.TosText}>
                      By signing up, I agree with Takbir’s{" "}
                      <a
                        href="https://mytakbir.com/terms-of-service"
                        target="_blank"
                      >
                        Terms
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://mytakbir.com/privacy-policy"
                        target="_blank"
                      >
                        Privacy policy.
                      </a>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Buttons
                      label="Continue"
                      buttonColor="#004FE0"
                      border="#ccc 1px solid"
                      color="#fff"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() => signUpStepOne(values)}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className={styles.AlreadyText}>
                      Already have an account?{" "}
                      <a onClick={() => props.handleClose()}>
                        <span onClick={() => props.handleOpen()}>Sign in</span>
                      </a>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className={styles.OrDevider}>
                      <span>or</span>
                    </div>
                  </Grid>

                  {props.signUpWith == "phone_number" && (
                    <Grid item xs={12} md={12}>
                      <div
                        className="SocialButton"
                        onClick={(e) => props.setSignUpWith("email")}
                      >
                        <Buttons
                          label="Sign up with email"
                          buttonColor="#fff"
                          border="#E4E8EC 1px solid"
                          color="#004FE0"
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          onClick={(e) => props.setSignUpWith("email")}
                          icon={<MailOutlineRoundedIcon />}
                        />
                      </div>
                    </Grid>
                  )}

                  {props.signUpWith == "email" && (
                    <Grid item xs={12} md={12}>
                      <div
                        className="SocialButton"
                        onClick={(e) => props.setSignUpWith("phone_number")}
                      >
                        <Buttons
                          label="Sign up with phone"
                          buttonColor="#fff"
                          border="#E4E8EC 1px solid"
                          color="#004FE0"
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          onClick={(e) => props.setSignUpWith("phone_number")}
                          icon={<CallTwoToneIcon />}
                          IconAlign="left"
                        />
                      </div>
                    </Grid>
                  )}

                  <Grid item xs={12} md={12}>
                    <div className={styles.TosTextGoogle}>
                      This site is protected by reCAPTCHA and the Google{" "}
                      <br></br>
                      <a
                        href="https://mytakbir.com/terms-of-service"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://mytakbir.com/terms-of-service"
                        target="_blank"
                      >
                        Terms of Service
                      </a>{" "}
                      apply.{" "}
                    </div>
                  </Grid>
                </>
              )}
            </Grid>

            {/* <Grid item xs={12} md={6}>
              <div className="Recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITEKEY}
                  onChange={handleReCaptcha}
                />
              </div>
            </Grid> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUp;
